// Catálogo de treinos do Coach V2 — entrega de UM drill prático por intenção.
// Cada drill segue a estrutura obrigatória da spec (incluindo material de apoio).
// A biblioteca/trilhas antigas continuam intactas como fallback.

export const GPH_DRILLS = [
  {
    drillId: 'strafe_short_trade',
    title: 'Strafe para Vencer Troca Curta',
    goals: ['strafe', 'movimentacao', 'troca curta'],
    keywords: ['strafe', 'troca curta', 'trocacao', 'trocação'],
    scenario: 'Trocas de tiro em distância curta, quando você e o inimigo se veem ao mesmo tempo.',
    fixesMistake: 'Ficar parado ou andar em linha reta durante a troca, virando alvo fácil.',
    whyItWorks: 'O strafe quebra a previsibilidade do seu hitbox e força o inimigo a corrigir a mira enquanto você mantém a sua estável.',
    howToExecute: [
      'Encontre um alvo fixo (parede ou boneco de treino).',
      'Atire em bursts curtos enquanto alterna A/D (esquerda/direita) em ritmo irregular.',
      'Mantenha a mira na altura do peito durante todo o movimento.',
      'Pare de atirar quando trocar de direção, retome no meio do movimento.'
    ],
    commonErrors: ['Strafe em ritmo constante (previsível)', 'Baixar a mira ao trocar de direção', 'Spray contínuo sem burst'],
    howToTrain: '10 séries de 20 segundos no treino, alternando ritmo do strafe a cada série.',
    howToValidate: 'Se em partidas reais você sobreviver a mais trocas curtas e sentir a mira estável durante o movimento, funcionou.',
    supportMaterial: {
      checklist: ['Mira na altura do peito', 'Ritmo irregular', 'Burst curto', 'Reposicionar após cada troca'],
      tip: 'Dica da Mi: comece devagar. Velocidade sem controle só treina erro.',
      easierVariation: 'Strafe sem atirar, apenas mantendo a mira no alvo.',
      harderVariation: 'Strafe + jump ocasional + troca de alvo entre dois pontos.',
      complementaryDrillId: 'reset_lost_trade'
    }
  },
  {
    drillId: 'timing_break_vs_rush',
    title: 'Quebra de Timing Contra Rush',
    goals: ['rush', 'defesa'],
    keywords: ['rush', 'defender rush', 'quebra de timing'],
    scenario: 'Defesa contra rush dentro de casa ou em cover fechado.',
    fixesMistake: 'Ficar parado esperando o inimigo entrar e deixar ele controlar o timing.',
    whyItWorks: 'Você muda o ângulo antes da entrada e força o inimigo a recalcular a mira, ganhando o primeiro tiro.',
    howToExecute: [
      'Escute o avanço do inimigo (passos/vault).',
      'Recue meio passo do ângulo esperado.',
      'Troque o ângulo de espera imediatamente antes da entrada.',
      'Faça repeek curto e resete a posição se errar os primeiros tiros.'
    ],
    commonErrors: ['Abrir demais o ângulo', 'Ficar parado no mesmo ponto', 'Aceitar troca longa depois de perder o timing'],
    howToTrain: '10 repetições por lado em uma casa do treino, alternando cover curto e porta.',
    howToValidate: 'Se você sobrevive mais às entradas e força o inimigo a errar o primeiro spray, funcionou.',
    supportMaterial: {
      checklist: ['Ouvir antes de reagir', 'Mudar ângulo antes da entrada', 'Repeek curto', 'Reset rápido'],
      tip: 'Dica da Mi: o rush morre quando o timing do atacante quebra. Seu trabalho é quebrá-lo.',
      easierVariation: 'Treinar apenas a troca de ângulo, sem atirar.',
      harderVariation: 'Defender contra dois pontos de entrada simultâneos.',
      complementaryDrillId: 'stairs_push_defense'
    }
  },
  {
    drillId: 'stairs_push_defense',
    title: 'Defesa Contra Push em Escada',
    goals: ['escada', 'defesa'],
    keywords: ['escada', 'defender escada', 'push escada'],
    scenario: 'Você está no andar de cima e o inimigo força a subida pela escada.',
    fixesMistake: 'Mirar no meio da escada e ser surpreendido pelo peek do inimigo na quina.',
    whyItWorks: 'Segurar o ângulo alto da escada obriga o inimigo a se expor primeiro, com a cabeça na sua linha de tiro.',
    howToExecute: [
      'Posicione-se recuado da borda, com a mira fixa no topo da escada.',
      'Use o áudio para prever o momento da subida.',
      'Dispare no primeiro pixel visível (cabeça/ombro).',
      'Se errar, recue para o segundo cover — nunca troque na borda.'
    ],
    commonErrors: ['Mirar baixo demais', 'Ficar colado na borda', 'Não ter cover secundário planejado'],
    howToTrain: '8 repetições segurando o ângulo + 8 repetições recuando para o segundo cover.',
    howToValidate: 'Se o inimigo passou a morrer na subida ou desistir do push, o ângulo está certo.',
    supportMaterial: {
      checklist: ['Mira no topo da escada', 'Distância da borda', 'Cover secundário definido'],
      tip: 'Dica da Mi: escada é armadilha para quem sobe — desde que você não desça a mira.',
      easierVariation: 'Treinar só o posicionamento e a altura da mira, sem inimigo.',
      harderVariation: 'Defender escada com granada/utilitário chegando antes do push.',
      complementaryDrillId: 'timing_break_vs_rush'
    }
  },
  {
    drillId: 'reset_lost_trade',
    title: 'Reset de Trocação Perdida',
    goals: ['reset', 'trocacao', 'x1_casa'],
    keywords: ['reset', 'perdi a troca', 'trocacao perdida', 'trocação perdida'],
    scenario: 'Você tomou os primeiros tiros ou errou o spray inicial em uma troca.',
    fixesMistake: 'Insistir na troca perdida e morrer com a vida baixa em vez de resetar.',
    whyItWorks: 'Sair da linha de tiro zera a vantagem do inimigo e devolve o controle do timing para você.',
    howToExecute: [
      'Ao perceber a desvantagem, corte a linha de visão imediatamente (cover/smoke).',
      'Cure ou recarregue apenas atrás de cover seguro.',
      'Troque de ângulo — nunca volte pelo mesmo lugar.',
      'Reentre na luta apenas com vida e posição favoráveis.'
    ],
    commonErrors: ['Voltar pelo mesmo ângulo', 'Curar em cover exposto', 'Forçar a troca com vida baixa'],
    howToTrain: 'Simule 10 trocas perdidas no treino: a cada uma, execute o ciclo cortar visão → curar → trocar ângulo.',
    howToValidate: 'Se suas mortes por "insistência" caírem e você voltar a vencer lutas após reset, funcionou.',
    supportMaterial: {
      checklist: ['Cortar linha de visão', 'Curar em segurança', 'Novo ângulo', 'Reentrada consciente'],
      tip: 'Dica da Mi: perder a primeira troca não é perder a luta. É perder se você não resetar.',
      easierVariation: 'Treinar apenas o recuo para cover após tomar dano.',
      harderVariation: 'Reset com rotação completa para as costas do inimigo.',
      complementaryDrillId: 'strafe_short_trade'
    }
  },
  {
    drillId: 'isolate_1v1_vs_squad',
    title: 'Isolamento de 1v1 Contra Squad',
    goals: ['x1_casa', 'squad'],
    keywords: ['isolar', 'squad', '1v4', 'contra squad', 'x1 contra squad'],
    scenario: 'Você está sozinho contra um squad e precisa transformar 1v4 em vários 1v1.',
    fixesMistake: 'Trocar tiro com o squad inteiro ao mesmo tempo em campo aberto.',
    whyItWorks: 'Usando geometria do mapa e timing, você força apenas um inimigo por vez a aparecer na sua linha de tiro.',
    howToExecute: [
      'Escolha um cover que só tenha UMA linha de entrada visível.',
      'Provoque o push (dano ou som) e espere o primeiro inimigo isolado.',
      'Elimine e troque de posição imediatamente após cada abate.',
      'Nunca lute a segunda luta do mesmo lugar da primeira.'
    ],
    commonErrors: ['Ficar no mesmo cover após o abate', 'Escolher cover com múltiplas entradas', 'Forçar dano em dois inimigos ao mesmo tempo'],
    howToTrain: 'No treino ou partidas casuais, pratique o ciclo abate → reposição 10 vezes.',
    howToValidate: 'Se os confrontos contra squad virarem sequências de duelos individuais, o isolamento está funcionando.',
    supportMaterial: {
      checklist: ['Uma linha de entrada', 'Provocação controlada', 'Reposição pós-abate'],
      tip: 'Dica da Mi: contra squad, o mapa é seu segundo aliado. Use as paredes como parceiro de jogada.',
      easierVariation: 'Praticar apenas a escolha de covers com entrada única.',
      harderVariation: 'Isolar em zona final com círculo fechando.',
      complementaryDrillId: 'smoke_reposition'
    }
  },
  {
    drillId: 'smoke_reposition',
    title: 'Uso de Smoke para Reposicionamento',
    goals: ['smoke', 'reposicionamento', 'utilitario'],
    keywords: ['smoke', 'fumaca', 'fumaça', 'reposicionar'],
    scenario: 'Você precisa atravessar área aberta sob pressão ou sair de uma posição comprometida.',
    fixesMistake: 'Usar a smoke em cima de si mesmo e continuar no mesmo lugar, entregando a posição.',
    whyItWorks: 'A smoke corta a informação do inimigo. Quem se move junto com ela decide onde a próxima luta acontece.',
    howToExecute: [
      'Jogue a smoke ENTRE você e o inimigo, não em cima de você.',
      'Espere a smoke abrir completamente antes de mover.',
      'Mova-se pela borda da smoke, nunca pelo centro.',
      'Saia em um ângulo que o inimigo não espera (flanco).'
    ],
    commonErrors: ['Atravessar pelo centro da smoke', 'Mover antes da smoke abrir', 'Usar smoke sem plano de destino'],
    howToTrain: '10 repetições: jogar smoke, contar a abertura, atravessar pela borda até o próximo cover.',
    howToValidate: 'Se você parar de tomar spray "aleatório" dentro da smoke e chegar vivo ao destino, funcionou.',
    supportMaterial: {
      checklist: ['Smoke entre você e o inimigo', 'Esperar abertura', 'Borda, não centro', 'Destino definido antes de jogar'],
      tip: 'Dica da Mi: smoke não é escudo, é troca de informação. Use o tempo dela para mudar o mapa mental do inimigo.',
      easierVariation: 'Treinar apenas o arremesso na distância certa.',
      harderVariation: 'Smoke + flanco completo para as costas do inimigo.',
      complementaryDrillId: 'pinch_escape'
    }
  },
  {
    drillId: 'short_repeek_punish',
    title: 'Repeek Curto para Punir Entrada',
    goals: ['repeek', 'defesa', 'punir'],
    keywords: ['repeek', 'punir entrada', 'peek'],
    scenario: 'O inimigo acabou de te ver e espera que você apareça no mesmo ângulo.',
    fixesMistake: 'Repetir o mesmo peek no mesmo ângulo e na mesma altura, direto na mira do inimigo.',
    whyItWorks: 'O repeek curto em ângulo/altura diferente pega o inimigo com a mira fixada no ponto errado.',
    howToExecute: [
      'Após o primeiro peek, saia completamente da linha de visão.',
      'Conte meio segundo (o tempo do inimigo fixar a mira).',
      'Reapareça 1 passo ao lado ou agachado — nunca no mesmo pixel.',
      'Dispare burst curto e saia de novo.'
    ],
    commonErrors: ['Repeek no mesmo ângulo', 'Repeek longo (exposto demais)', 'Repeek sem bala no pente'],
    howToTrain: '10 séries: peek → sair → repeek deslocado, alternando lado e altura.',
    howToValidate: 'Se os inimigos passarem a errar o primeiro tiro no seu repeek, o deslocamento está funcionando.',
    supportMaterial: {
      checklist: ['Sair 100% da linha', 'Meio segundo de espera', 'Novo ângulo/altura', 'Burst e sai'],
      tip: 'Dica da Mi: o inimigo mira onde você ESTAVA. O repeek vence quando você aparece onde ele não mira.',
      easierVariation: 'Treinar o deslocamento lateral sem atirar.',
      harderVariation: 'Repeek com troca de altura (agachar/levantar) e de lado ao mesmo tempo.',
      complementaryDrillId: 'timing_break_vs_rush'
    }
  },
  {
    drillId: 'pinch_escape',
    title: 'Saída de Pinçamento',
    goals: ['pincamento', 'escape'],
    keywords: ['pincamento', 'pinçamento', 'cercado', 'sair do cerco'],
    scenario: 'Dois inimigos ou squads atacam você de ângulos opostos ao mesmo tempo.',
    fixesMistake: 'Tentar trocar com os dois lados ao mesmo tempo e morrer sem decidir a luta.',
    whyItWorks: 'Escolher UM lado e forçar a saída por ele transforma o pinçamento em uma única luta — a que você escolheu.',
    howToExecute: [
      'Identifique o lado mais fraco (menos dano recebido / menos inimigos).',
      'Corte a visão do lado forte (smoke/cover/granada).',
      'Force a saída pelo lado fraco com agressividade total.',
      'Não pare de mover até quebrar a linha do cerco.'
    ],
    commonErrors: ['Dividir atenção entre os dois lados', 'Hesitar no meio da saída', 'Sair pelo lado forte'],
    howToTrain: 'Simule mentalmente em 10 partidas: ao ser pinçado, declare o lado fraco em voz alta e execute a saída.',
    howToValidate: 'Se você sair vivo de mais pinçamentos (mesmo sem abates), o padrão de decisão melhorou.',
    supportMaterial: {
      checklist: ['Identificar lado fraco', 'Cortar visão do lado forte', 'Saída agressiva', 'Movimento contínuo'],
      tip: 'Dica da Mi: pinçamento mata quem hesita. Decisão rápida errada > indecisão perfeita.',
      easierVariation: 'Treinar apenas a leitura de qual lado é o fraco.',
      harderVariation: 'Sair do pinçamento e punir o lado forte pelas costas.',
      complementaryDrillId: 'smoke_reposition'
    }
  },
  {
    drillId: 'broken_cover_defense',
    title: 'Defesa com Cover Quebrado',
    goals: ['cover', 'defesa'],
    keywords: ['cover quebrado', 'sem cover', 'cover destruido', 'cover destruído'],
    scenario: 'Seu cover foi destruído ou é insuficiente e o inimigo mantém pressão de tiro.',
    fixesMistake: 'Congelar atrás de um cover que não existe mais e absorver o spray.',
    whyItWorks: 'Movimento imediato para o próximo cover real remove você da linha de tiro pré-fixada do inimigo.',
    howToExecute: [
      'Antes de cada luta, marque mentalmente o SEGUNDO cover mais próximo.',
      'Ao perder o cover, mova imediatamente em zigue-zague curto.',
      'Use utilitário (smoke/granada) para cobrir a transição se disponível.',
      'Reassuma a luta apenas do novo cover.'
    ],
    commonErrors: ['Não ter segundo cover planejado', 'Correr em linha reta', 'Trocar tiro durante a transição'],
    howToTrain: '10 repetições de transição entre covers sob pressão simulada no treino.',
    howToValidate: 'Se você parar de morrer "parado" quando o cover cai, o reflexo de transição está instalado.',
    supportMaterial: {
      checklist: ['Segundo cover marcado', 'Zigue-zague curto', 'Utilitário na transição'],
      tip: 'Dica da Mi: cover não é onde você está — é para onde você pode ir.',
      easierVariation: 'Mapear covers secundários em áreas conhecidas, sem luta.',
      harderVariation: 'Transição de cover com cura no meio do caminho.',
      complementaryDrillId: 'reset_lost_trade'
    }
  },
  {
    drillId: 'house_entry_sound_bait',
    title: 'Entrada em Casa com Bait de Som',
    goals: ['entrada', 'bait', 'x1_casa'],
    keywords: ['entrada em casa', 'bait', 'bait de som', 'entrar na casa', 'x1 dentro de casa'],
    scenario: 'Você precisa entrar em uma casa defendida e o inimigo segura o ângulo da porta.',
    fixesMistake: 'Entrar direto pela porta principal, no timing exato que o defensor espera.',
    whyItWorks: 'O som falso desloca a mira e a atenção do defensor para o lugar errado no momento da entrada real.',
    howToExecute: [
      'Provoque som em uma entrada (passos/vault fake) e NÃO entre por ela.',
      'Conte 1 segundo — tempo do defensor fixar a mira no som.',
      'Entre pela segunda rota (janela/porta alternativa) com clear rápido de ângulo.',
      'Limpe primeiro o ângulo mais provável do defensor, não o mais visível.'
    ],
    commonErrors: ['Entrar pela mesma rota do bait', 'Bait sem rota alternativa', 'Entrada lenta após o bait'],
    howToTrain: '10 entradas alternando qual rota recebe o bait e qual recebe a entrada real.',
    howToValidate: 'Se você pegar defensores olhando para o lugar errado, o bait está funcionando.',
    supportMaterial: {
      checklist: ['Duas rotas mapeadas', 'Som na rota falsa', '1 segundo de espera', 'Entrada rápida na rota real'],
      tip: 'Dica da Mi: em FPS mobile, som é informação. Quem controla o som controla a mira do inimigo.',
      easierVariation: 'Treinar apenas o mapeamento de rotas duplas das casas do mapa.',
      harderVariation: 'Bait duplo: som na rota A, granada na rota B, entrada pela rota C.',
      complementaryDrillId: 'isolate_1v1_vs_squad'
    }
  },
  {
    drillId: 'vertical_recoil_control',
    title: 'Controle Vertical de Spray',
    goals: ['controle de spray', 'recoil', 'spray', 'controle vertical'],
    keywords: ['spray sobe', 'mira sobe', 'recoil vertical', 'controle de recoil', 'segurar o spray'],
    scenario: 'Sprays médios e longos em que sua mira sobe e sai do alvo depois das primeiras balas.',
    fixesMistake: 'Compensar o recoil com força irregular, deixando a mira subir ou afundar no meio do spray.',
    whyItWorks: 'A compensação vertical constante e calibrada mantém o agrupamento no mesmo ponto durante todo o pente — recoil se vence com ritmo, não com força.',
    howToExecute: [
      'No campo de treino, marque um ponto na parede a 20 metros.',
      'Dispare sprays completos (30 balas) puxando a mira para baixo em ritmo CONSTANTE.',
      'Observe onde o agrupamento abre: se sobe, aumente a compensação; se afunda, diminua.',
      'Repita a 30 e 40 metros ajustando a intensidade da puxada, nunca o ritmo.'
    ],
    commonErrors: ['Puxar forte só no começo do spray', 'Compensar em solavancos', 'Trocar de distância antes de estabilizar a atual'],
    howToTrain: '3 séries de 5 sprays completos em cada distância (20/30/40m), com pausa entre séries.',
    howToValidate: 'Se o agrupamento das últimas 10 balas ficar na mesma zona das primeiras 10, o controle vertical está instalado.',
    supportMaterial: {
      checklist: ['Ritmo constante de compensação', 'Agrupamento observado a cada spray', 'Três distâncias treinadas'],
      tip: 'Dica da Mi: se a mira sobe sempre no mesmo ponto do pente, o problema é sensibilidade — não força. Considere ajustar o ADS/Gyro.',
      easierVariation: 'Sprays de 15 balas apenas a 20 metros.',
      harderVariation: 'Spray completo alternando entre dois pontos na parede.',
      complementaryDrillId: 'spray_tracking_moving'
    }
  },
  {
    drillId: 'spray_tracking_moving',
    title: 'Spray Tracking em Alvo Móvel',
    goals: ['tracking', 'acompanhamento', 'spray tracking'],
    keywords: ['nao acompanha', 'não acompanha', 'acompanhar inimigo', 'alvo em movimento', 'tracking', 'mira treme'],
    scenario: 'Inimigos strafando ou correndo lateralmente enquanto você precisa manter o spray no corpo.',
    fixesMistake: 'Mirar onde o inimigo estava, corrigindo em saltos bruscos que abrem o spray.',
    whyItWorks: 'O tracking contínuo treina a mão a mover a mira na velocidade do alvo, eliminando as micro-correções que causam tremor e perda de spray.',
    howToExecute: [
      'No treino, escolha um boneco/alvo e mova-se lateralmente (strafe) mantendo a mira travada nele.',
      'Alterne a direção do seu strafe sem deixar a mira sair do alvo.',
      'Adicione o disparo: bursts de 5-8 balas mantendo o tracking durante o movimento.',
      'Aumente a velocidade do strafe gradualmente, só depois que o tracking estabilizar.'
    ],
    commonErrors: ['Corrigir a mira em saltos', 'Parar o movimento para atirar', 'Aumentar velocidade antes de estabilizar'],
    howToTrain: '5 séries de 30 segundos de tracking sem atirar + 5 séries com burst, por sessão.',
    howToValidate: 'Se a retícula permanecer no alvo durante trocas de direção, seu tracking está pronto para duelo real.',
    supportMaterial: {
      checklist: ['Mira travada durante strafe', 'Correção contínua, não em saltos', 'Burst mantendo tracking'],
      tip: 'Dica da Mi: tracking ruim com sensibilidade alta parece tremor. Estabilize o movimento antes de culpar a mira.',
      easierVariation: 'Tracking parado em alvo móvel (sem strafe próprio).',
      harderVariation: 'Tracking com strafe + jump do alvo em distância variável.',
      complementaryDrillId: 'vertical_recoil_control'
    }
  },
  {
    drillId: 'flick_two_targets',
    title: 'Flick Controlado Entre Dois Alvos',
    goals: ['flick', 'controle de flick', 'transicao de mira'],
    keywords: ['passa do alvo', 'mira passa', 'flick', 'virar rapido', 'virar rápido'],
    scenario: 'Trocas rápidas de alvo em que sua mira passa do ponto e você precisa corrigir de volta.',
    fixesMistake: 'Flick com força total e correção dupla — a mira passa do alvo, volta, e passa de novo.',
    whyItWorks: 'O flick em duas fases (aceleração + freio) ensina a mão a parar a mira NO alvo, eliminando a correção que custa o primeiro tiro.',
    howToExecute: [
      'Escolha dois alvos fixos separados por 10 metros no campo de treino.',
      'Alterne a mira entre eles em velocidade média, parando EXATAMENTE no alvo.',
      'Só aumente a velocidade quando parar de passar do ponto.',
      'Adicione um disparo único a cada chegada — flick, tiro, flick, tiro.'
    ],
    commonErrors: ['Velocidade máxima antes da precisão', 'Corrigir com segundo flick', 'Ignorar a parada (freio) do movimento'],
    howToTrain: '10 séries de 20 transições entre os dois alvos, aumentando a velocidade a cada 2 séries limpas.',
    howToValidate: 'Se você parar no alvo sem correção em 8 de 10 flicks, a transição está calibrada.',
    supportMaterial: {
      checklist: ['Parada exata no alvo', 'Velocidade progressiva', 'Um tiro por chegada'],
      tip: 'Dica da Mi: se a mira passa SEMPRE do alvo, sua sensibilidade de câmera está rápida demais para seu tempo de freio.',
      easierVariation: 'Alvos separados por 5 metros, sem disparo.',
      harderVariation: 'Três alvos em triângulo com burst curto em cada um.',
      complementaryDrillId: 'spray_tracking_moving'
    }
  },
  {
    drillId: 'burst_control_distance',
    title: 'Burst Control por Distância',
    goals: ['burst', 'controle vertical', 'media distancia'],
    keywords: ['rajada', 'burst', 'tiro cai', 'mira cai', 'media distancia', 'média distância'],
    scenario: 'Duelos de média distância em que o spray completo abre demais e o burst é a arma certa.',
    fixesMistake: 'Segurar o dedo no gatilho em média distância e perder o duelo para quem dá rajadas curtas.',
    whyItWorks: 'Bursts de 3-5 balas resetam o recoil entre rajadas, mantendo a precisão da primeira bala em cada sequência.',
    howToExecute: [
      'Marque um alvo a 50 metros no campo de treino.',
      'Dispare bursts de 3 balas com pausa de meio segundo entre cada um.',
      'Observe o agrupamento: cada burst deve acertar a mesma zona.',
      'Suba para bursts de 5 balas apenas quando os de 3 estiverem agrupados.'
    ],
    commonErrors: ['Burst longo demais (vira spray)', 'Pausa curta demais (recoil não reseta)', 'Reposicionar a mira só depois do burst'],
    howToTrain: '4 séries de 10 bursts em 40m e 4 séries em 50m por sessão.',
    howToValidate: 'Se cada burst agrupar na mesma zona a 50 metros, seus duelos de média distância vão virar.',
    supportMaterial: {
      checklist: ['3-5 balas por rajada', 'Pausa de reset entre bursts', 'Mira reposicionada durante a pausa'],
      tip: 'Dica da Mi: em média distância, quem controla o ritmo do tiro controla o duelo. Burst é ritmo, não pressa.',
      easierVariation: 'Bursts de 3 balas a 30 metros.',
      harderVariation: 'Bursts alternando alvo entre 40 e 60 metros.',
      complementaryDrillId: 'vertical_recoil_control'
    }
  }
];

const stripAccents = (value = '') =>
  String(value).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export const findDrillByGoal = (goalOrText = '') => {
  const normalized = stripAccents(goalOrText);
  if (!normalized) return null;

  let best = null;
  let bestScore = 0;
  for (const drill of GPH_DRILLS) {
    let score = 0;
    for (const goal of drill.goals) {
      if (normalized.includes(stripAccents(goal))) score += 3;
    }
    for (const keyword of drill.keywords) {
      if (normalized.includes(stripAccents(keyword))) score += 2;
    }
    if (score > bestScore) {
      best = drill;
      bestScore = score;
    }
  }
  return best;
};

export const getDrillById = (drillId) =>
  GPH_DRILLS.find((drill) => drill.drillId === drillId) || null;

export default GPH_DRILLS;
